
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgEventSendHostEmail extends Vue {
    @Prop({type: Object, default: () => ({})}) public event!: any;
    @Prop({type: Object, default: () => ({})}) public host!: any;
    @Prop({type: Boolean, default: false}) public value!: boolean;

    @Action('admin/events/sendHostMail') private sendHostMail!: any;

    @Getter('common/rules/all') private rules!: any;
    @Getter('admin/events/templates') private templates!: any;

    private loading: boolean = false;
    private selectedTemplate: string = '';
    private type: number = 1;

    private selectTemplate(template) {
      if (this.loading) {
        return;
      }
      this.selectedTemplate = template.id;
    }

    get dialog() {
      return this.value;
    }

    set dialog(val) {
      this.$emit('input', val);
    }

    private async send() {
      this.loading = true;
      await this.sendHostMail({eventId: this.event.id, templateId: this.selectedTemplate, hostId: this.host.id});
      this.loading = false;
      this.selectedTemplate = '';
      this.dialog = false;
    }
  }
